<template>
    <div>
        <v-card flat id="lead_order_datatable">
            <v-container fluid class="ma-0 pa-0 pb-2 q_leads_1" :id="entity + '_datatable'">
                <v-row>
                    <v-col cols="12" sm="8" id="q-pending-policy-step-3" class="mb-0 pb-0 px-7 text-left">
                        <p class="q-display-3 pb-0 pt-0 mt-0 mb-0 white--text">Downline Lead Orders
                            <v-btn dark icon @click="refresh">
                                <v-icon>fas fa-redo-alt</v-icon>
                            </v-btn>
                        </p>
                    </v-col>
                    <v-col cols="12" sm="4" class="pr-8 pl-7 pr-3 mb-0 pb-0 d-flex justify-end">
                        <v-spacer></v-spacer>
                        <v-text-field dense dark v-model="search" :disabled="isDemoMode" append-icon="icon-q-search" label="Search" single-line hide-details></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
            <div class="px-4">
				<q-filters dark ref="filters" v-model="filters" :available-filters="available_filters" :keys="filter_keys" :show-reset="true" />
            </div>
            <v-data-table v-on:current-items="updateCurrentItems" :mobile-breakpoint="2" :search="search" v-model="selected" :headers="the_headers" :items="all_data" item-key="ID" class="elevation-0 lead-order-table" :footer-props="{itemsPerPageOptions:[50, 100, 200, 300]}" :loading="loading" :options.sync="options">
                <template v-slot:item.AgentName="{ item }">
                    <span class="nowrap">
                        <router-link :to="'/agents/' + item.AgentCode">{{item.AgentName}}</router-link>
                    </span>
                </template>
                <template v-slot:item.SwitchboardConfig="{ item }">
                    <span>
                        <v-icon v-if="item.SwitchboardConfig && item.SwitchboardConfig.location_id">fas fa-check</v-icon>
                    </span>
                </template>
                <template v-slot:item.FillRate="{ item }">
                    <span>
                        {{ formatPercentage(item.FillRate) }}
                    </span>
                </template>
                <template v-slot:item.OrderNumber="{ item }">
                    <span>
                        <v-tooltip top v-if="item.NeedsApproval">
                            <template v-slot:activator=" { on, attrs }">
                                {{item.OrderNumber}}
                                    <v-btn icon to="/leads/approve-digital-lead-orders">
                                        <v-icon color="yellow" :x-small="true" v-on="on">fas fa-exclamation-triangle</v-icon>
                                    </v-btn>
                            </template>
                            <span>This order requires approval!</span>
                        </v-tooltip>
                        <v-tooltip top v-else-if="item.OrderStatus == 'Requires Balance'">
                            <template v-slot:activator=" { on, attrs }">
                                {{item.OrderNumber}}
                                    <v-btn icon to="/leads/approve-digital-lead-orders">
                                        <v-icon color="yellow" :x-small="true" v-on="on">fas fa-exclamation-triangle</v-icon>
                                    </v-btn>
                            </template>
                            <span>This order requires balance! Please have the agent update their credit card!</span>
                        </v-tooltip>
                        <span v-else>{{item.OrderNumber}}</span>
                    </span>
                </template>
                <template slot="body.append">
                    <tr>
                        <th class="title text-center" v-for="(header,ix) in the_headers" :key="ix">
                            <span v-if="header.value == 'AgentName'">
                                <v-btn v-if="the_data.length > 0" color="secondary" @click="exportResults">
                                    Download <v-icon>fas fa-download</v-icon>
                                </v-btn>
                            </span>
                            <span v-else-if="header.value == 'QtyRequested'">
                                {{ sumField('QtyRequested') }}
                            </span>
                            <span v-else-if="header.value == 'QtyFilled'">
                                {{ sumField('QtyFilled') }}
                            </span>
                            <span v-else-if="header.value == 'FillRate'">
                                {{ formatPercentage(sumField('QtyFilled') / sumField('QtyRequested')) }}
                            </span>
                        </th>
                    </tr>
                    
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>
<script>
import QuilityAPI from '@/store/API/QuilityAPI.js'
import { debounce } from 'vue-debounce'
const { Parser } = require('json2csv');
import QFilters from '@/components/utils/QFilters.vue'
import moment from 'moment'
import { weekdiff } from '@/components/utils/BusinessTimeDateDiff.js'

const orderStatusOptions = [
	{ status: 'Open', byDefault: true },
	{ status: 'New', byDefault: true },
	{ status: 'Requires Balance', byDefault: true },
	{ status: 'Pending Cancellation', byDefault: true },
	{ status: 'Draft', byDefault: false },
	{ status: 'Complete', byDefault: false },
	{ status: 'Canceled', byDefault: false },
	{ status: 'Paused by Agent', byDefault: false },
	{ status: 'Paused by Admin', byDefault: false },
	{ status: 'Order Declined', byDefault: false },
	{ status: 'In Review', byDefault: false },
]

const defaultOrderStatusFilter = orderStatusOptions
	.filter(({ byDefault }) => byDefault)
	.map(({ status }) => status)

const orderStatusFilterOptions = orderStatusOptions
	.map(({ status }) => ({
		text: status,
		value: status,
	}))

export default {
    name: "QBaseshopLeadOrderReportTable",
    props: ['agentCode'],
    data: function() { // data internal to component (not available outside)
        return {
            entity: 'lead_order',
            //use this to "preset" a filter
            filters: {
                //'LeadType': "Quility Digital Lead",
                //'GroupBy' : 'State',
                //"OrderType": "Standing Order",
				OrderStatus: defaultOrderStatusFilter,
                Weeks : null,
            }, //these are the filters the user has set or you can preset them
			options: {
                'sortBy': ['OrderDate'], //used to set the default sorting column
                'sortDesc': [false],
            },
            the_data: [], //this will hole the data fromt he server now that we aren't using vuex anymore.
            search: null,
            selected: [],
            data_loading: false,
        }
    },
    mounted: function() {
        this.$nextTick(() => {
            //this.filters.Weeks = this.available_filters.Weeks[0]
        })
        this.refreshData()
    },
	activated () {
		this.$refs.filters?.hide()
	},
    computed: {
        loading: function() {
            return this.data_loading;
        },
        all_data: function() {
            return this.the_data;
        },
        filter_keys: function() {
            return ['OrderStatus', 'Weeks'] // this must sync up with availableFilters in the Model in Laravel.
        },
        total_items: function() {
            return this.the_data.length;
        },
        the_headers () {
            return [{
                text: 'Agent',
                value: 'AgentName',
                align: "left"
            }, {
                text: 'Has Switchboard',
                value: 'SwitchboardConfig',
                align: "center"
            }, {
                text: 'Order #',
                value: 'OrderNumber',
                align: "left"
            }, {
                text: 'Order Type',
                value: 'OrderType',
                align: "left"
            }, {
                text: 'Order Status',
                value: 'OrderStatus',
                align: 'left'
            }, {
                text: 'LeadType',
                value: 'LeadType',
                align: "left"
            }, {
                text: '# Requested',
                value: 'QtyRequested',
                align: "center"
            }, {
                text: '# Filled',
                value: 'QtyFilled',
                align: "center"
            }, {
                text: 'Fill Rate',
                value: 'FillRate',
                align: "center"
            }, {
                text: 'States',
                value: 'OrderStates',
                align: "center"
            }]
        },
        available_filters: function() {
            var weeks = this.getAvailableBusinessDates('weeks', false, true, '2022-07-01');
            var week_selection = [];
            weeks.forEach((w) => {
                week_selection.push({
                    text : w.label,
                    value : {
                        endDate : w.endDateFormat,
                        startDate : w.startDateFormat,
                        'disableMultiple' : true
                    }
                })
            })
            return {
                //"GroupBy": ["State", "Product", "Order", "Agency", "Agent"],
                //"LeadType": ["Quility Digital Lead", "Recruiting"],
                //"OrderType": ["Standing Order", "One-time Order"],
				OrderStatus: orderStatusFilterOptions,
                Weeks : week_selection,
            };
        },
        export_fields () {
			return this.the_headers.map((item) => item.value)
        },
    },
    methods: {
        loadData: debounce(function(opt) {
            this.data_loading = true
            let d = this.filters.Weeks
            let openOnly = false
            // drop down returns null for current week... so we need to generate the correct dates. 
            if (typeof d === 'undefined' || d === '-All-' || d.startDate === null) {
                const day_of_the_week = moment().format('dddd')
                const current = moment().subtract(weekdiff[day_of_the_week]['saturday'], 'days')
                d = {
                    startDate: moment(current).format('YYYY-MM-DD'),
                    endDate: moment(current).add(6, 'days').format('YYYY-MM-DD'),
                }
                openOnly = true
            }
            const filters = {
                //GroupBy: this.filters.GroupBy,
                //LeadType: this.filters.LeadType,
                //OrderType : this.filters.OrderType,
                startDate : d.startDate + " 00:00:00",
                endDate : d.endDate + " 23:59:59",
				status: this.filters.OrderStatus.length ? this.filters.OrderStatus.join(',') : null,
                openOnly,
            }
            this.the_data = []
            QuilityAPI.getBaseshopLeadOrderReport(this.agentCode, filters, opt)
				.then((json) => {
					this.data_loading = false
					this.the_data = json.data
				})
				.catch((error) => {
					if (error.message === 'Aborted') {
						return
					}
					this.showError('There was a problem getting the data.<br>', error.message)
					this.data_loading = false
				})
        }, 200),
        refresh: function() {
            this.the_data = []
            this.refreshData();
        },
        refreshData: function(search) {
            var opt = {
                ...this.options,
            }
            this.expanded = [];
            this.loadData(opt);
        },
        updateCurrentItems: function(items) {
            this.currentItems = items;
        },
        alignClass: function(header) {
            if (header.align == "center") {
                return "text-middle text-center"
            }
            if (header.align == "left") {
                return "text-start text-center"
            }
            if (header.align == "right") {
                return "text-end"
            }
        },
        exportResults: function() {
            const opts = { fields: [...this.export_fields] }
            try {
                var parser = new Parser(opts);
                var csv = parser.parse(this.the_data);
                var fileURL = window.URL.createObjectURL(new Blob([csv]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                var fileName = this.slugify('BaseshopLeadOrders_' + this.formatDate());
                fileLink.setAttribute('download', fileName + ".csv");
                document.body.appendChild(fileLink);
                fileLink.click();
                this.logActivity("Baseshop Lead Orders Report Export", {})
            } catch (err) {
                console.error(err);
            }
        },
        sumField(key) {
            return this.all_data.reduce((a, b) => a + (Number(b[key]) || 0), 0)
        }
    },
    watch: {
        'filters': {
            deep: true,
            handler(newV, oldV) {
                this.options.page = 1
                this.$nextTick(this.refreshData);
            }
        },
        'options': {
            deep: true,
            handler(newV) {
                /*var g = this;
                if (!this.firstPull) {
                    this.$vuetify.goTo('#' + this.entity + '_datatable', {
                        duration: 250,
                        easing: 'easeOutCubic',
                    });
                }
                this.$nextTick(g.refreshData)
                */
            }
        },
    },
    components: {
        QFilters,
    }
}
</script>
<style scoped>
.nowrap {
    white-space: nowrap;
}

.grey_row {
    background-color: #f7f7f7;
}

.lead-order-table {
    font-size: 12px;
}

.lead-order-line-table {
    background-color: #f7f7f7;
}

.lead-order-line-table table td {
    font-size: .9em;
    width: 10%;
}
</style>
<style>
.lead-divider {
    margin: 0 6px;
}
</style>